"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_1 = require("../../graphql");
const react_hooks_1 = require("@apollo/react-hooks");
// {
//   integration: Integration;
//   emailList: EmailList | null;
//   onChange: (newState: Partial<IState>) => void;
//   status: IState['status'];
// }
exports.useEspPushListSubscribers = (espId, listId, mailchimpData) => {
    const [mutate, mutationResult] = react_hooks_1.useMutation(graphql_1.espPushListSubscribers, {
        variables: {
            espId,
            listId,
            options: {
                mailchimp: mailchimpData,
            },
        },
    });
    return { mutate, mutationResult };
};
//# sourceMappingURL=useEspPushListSubscribers.js.map